import React, { Component, useState } from "react";
import axios from "axios";
import ConfigData from "../../ConfigurationData/ConfigData.json";
import { Buffer } from "buffer";

import { Button } from "@progress/kendo-react-buttons";
import { MaskedTextBox } from "@progress/kendo-react-inputs";

import classes from "./UpdateCreditCardOnFile.module.css";
import { getTokenFromStorage, getToken } from "../../api/RestServices";
import moment from "moment";
import { useLocation } from "react-router-dom";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import CardHeader from "@mui/material/CardHeader";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { Link } from "@mui/material";
import { Form, Field, FormElement, Text } from "@progress/kendo-react-form";
import MuiFormControlLabel from "@mui/material/FormControlLabel";

const UpdateCreditCardOnFile = (props) => {
  let urlAPI = ConfigData.apiURL;
  let appId = ConfigData.appId;
  const PageUrl = useLocation();
  let curDT = moment().format("MM/DD/YYYY hh:mm:ssA");
  const [UserID, setUserID] = useState(props.UserID);
  const [MemberUSEAID, setMemberUSEAID] = useState(
    props.objModelMembershipDetails.MembershipDataDetails.MemberID
  );
  const [form, setForm] = useState({
    dataCardType: "",
    dataCardNo: "",
    dataCardUserName: "",
    dataCardExpirationMonth: "",
    dataCardExpirationYear: "",
    dataCardSecurityCode: "",
    dataCardZipcode: "",
    dataCardEmail: "",
  });

  const [dataCardTypeErrorMessage, setDataCardTypeErrorMessage] = useState({});
  const [dataCardUserNameErrorMessage, setDataCardUserNameErrorMessage] =
    useState({});
  const [dataCardNoErrorMessage, setDataCardNoErrorMessage] = useState({});
  const [
    dataCardExpirationMonthErrorMessage,
    setDataCardExpirationMonthErrorMessage,
  ] = useState({});
  const [
    dataCardExpirationYearErrorMessage,
    setDataCardExpirationYearErrorMessage,
  ] = useState({});
  const [
    dataCardSecurityCodeErrorMessage,
    setDataCardSecurityCodeErrorMessage,
  ] = useState({});
  const [dataCardZipcodeErrorMessage, setDataCardZipcodeErrorMessage] =
    useState({});
  const [dataCardEmailErrorMessage, setDataCardEmailErrorMessage] = useState(
    {}
  );

  const [isPaymentSuccess, setIsPaymentSuccess] = useState(false);
  const [
    dataPaymentFailureShortErrorMessage,
    setDataPaymentFailureShortErrorMessage,
  ] = useState({});
  const [
    dataPaymentFailureLongErrorMessage,
    setDataPaymentFailureLongErrorMessage,
  ] = useState({});

  const onUpdateField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    // FIX 2026-09-30: the security code is digits only and exactly as long as the card needs -
    // 3 digits (Visa/Mastercard) or 4 (Amex). Also re-trim it when the card type changes.
    if (e.target.name === "dataCardSecurityCode" || e.target.name === "dataCardType") {
      const securityCodeLength = nextFormState.dataCardType === "2" ? 4 : 3;
      nextFormState.dataCardSecurityCode = (nextFormState.dataCardSecurityCode || "")
        .toString()
        .replace(/\D/g, "")
        .slice(0, securityCodeLength);
    }
    setForm(nextFormState);
  };

  const onSubmitForm = (e) => {
    e.preventDefault();
    // FIX 2026-09-30 (PCI): never log the card form - it holds the full card number and CVV.
    const isValid = formValidation();

    if (isValid) {
      console.log("About to enter payment post api");
      callPayment()
        .then((response) => {
          console.log("Call Payment done");
          console.log(response);
          // FIX 2026-09-30: an expired token returns no PaymentTransactionStatus - show a failure
          // message instead of crashing silently.
          if (!response || !response.PaymentTransactionStatus) {
            setIsPaymentSuccess(false);
            setDataPaymentFailureShortErrorMessage({
              ErrorMessage: "Your card could not be updated. Please try again.",
            });
            return;
          }
          if (response) {
            if (
              response.PaymentTransactionStatus.PaymentStatus === 1 &&
              response.PaymentTransactionStatus.PaymentStatusResultCode === "A"
            ) {
              if (response.PaymentTransactionStatus.TransactionStatus === 1) {
                // set the credit card type
                let strCreditCardType = "";
                strCreditCardType = form.dataCartType;
                console.log(form.dataCardType);
                switch (form.dataCardType) {
                  case "0":
                    strCreditCardType = "VISA";
                    break;
                  case "1":
                    strCreditCardType = "MASTERCARD";
                    break;
                  case "2":
                    strCreditCardType = "AMEX";
                    break;
                  default:
                    strCreditCardType = "";
                    break;
                }
                console.log(strCreditCardType);
                // extract the last 4 digits of the credit card no
                let strCreditCardNo = "";
                strCreditCardNo = form.dataCardNo.substring(
                  form.dataCardNo.length - 4
                );
                strCreditCardNo = "#" + strCreditCardNo;
                props.objModelMembershipDetails.CreditCardDetails.CreditCardType =
                  strCreditCardType;
                props.objModelMembershipDetails.CreditCardDetails.CreditCardNo =
                  strCreditCardNo;
                props.objModelMembershipDetails.CreditCardDetails.CreditCardExpirationMonth =
                  form.dataCardExpirationMonth;
                props.objModelMembershipDetails.CreditCardDetails.CreditCardExpirationYear =
                  form.dataCardExpirationYear;
                // FIX 2026-09-30: the card was just verified and stored, so it is usable now -
                // MembershipSettings' auto-renewal save check reads this status.
                props.objModelMembershipDetails.CreditCardDetails.CreditCardExpirationStatus =
                  "VALID";

                console.log(props.objModelMembershipDetails);
                setIsPaymentSuccess(true);
                props.updateIsPaymentDone(true);
              } else {
                setIsPaymentSuccess(false);
                // FIX 2026-09-30 (#7): the card was approved but could not be saved; there is no gateway
                // error code for this, so don't ask the API with an undefined code.
                showPaymentError(
                  null,
                  "Your card was approved but could not be saved on your account. Please try again, or contact USEA if this keeps happening."
                );
              }
            } else {
              setIsPaymentSuccess(false);
              let strPaymentStatusErrorCode =
                response.PaymentTransactionStatus.PaymentStatusErrorCode;
              callPaymentErrorDetails(strPaymentStatusErrorCode)
                .then((errResponse) =>
                  showPaymentError(
                    errResponse,
                    "Your card was declined. Please check the card details and try again."
                  )
                )
                .catch(() =>
                  showPaymentError(
                    null,
                    "Your card was declined. Please check the card details and try again."
                  )
                );
            }
          }
        })
        // FIX 2026-09-30: this used to be .catch({ function(error){...} }) - an OBJECT, not a
        // function - so no card-update error was ever handled or shown.
        .catch(function (error) {
          {
            setIsPaymentSuccess(false);
            setDataPaymentFailureShortErrorMessage({
              ErrorMessage: "Your card could not be updated. Please try again.",
            });
            const data = {
              AppId: ConfigData.appId,
              TokenId: getTokenFromStorage(),
              UserId: localStorage.getItem("UserId"),
              DateTime: curDT,
              PageUrl: PageUrl.pathname,
              ExceptionDetails: error.stack,
            };
            axios
              .post(urlAPI + "PostOSPortalLoggingExceptions", data)
              .then(function (response) {
                if (response.data.TokenInfoDetails.TokenResponse == "Expired") {
                  getToken();
                  axios.post(urlAPI + "PostOSPortalLoggingExceptions", data);
                }
              });
          }
        });
    }
  };
  const renewToken = async () => {
    getToken();
  };

  // FIX 2026-09-30 (#7): one safe place to show card-update errors. The old inline code crashed
  // when PaymentErrorDetails was null, had a reversed LongMessage check (== ""), and could leave
  // the member with no message at all - now there is always a message.
  const showPaymentError = (errResponse, fallbackMessage) => {
    const strPaymentFailureShortMessage = {};
    const strPaymentFailureLongMessage = {};
    const details = errResponse && errResponse.PaymentErrorDetails;
    if (details && details.ShortMessage) {
      strPaymentFailureShortMessage.ErrorMessage = details.ShortMessage;
    }
    if (details && details.LongMessage) {
      strPaymentFailureLongMessage.ErrorMessage = details.LongMessage;
    }
    if (!strPaymentFailureShortMessage.ErrorMessage && !strPaymentFailureLongMessage.ErrorMessage) {
      strPaymentFailureShortMessage.ErrorMessage = fallbackMessage;
    }
    setDataPaymentFailureShortErrorMessage(strPaymentFailureShortMessage);
    setDataPaymentFailureLongErrorMessage(strPaymentFailureLongMessage);
  };

  // FIX 2026-09-30 (#8): the card fields sit inside the Settings <form>, so pressing Enter in a
  // card field submitted the SETTINGS form instead of updating the card. Swallow Enter here.
  const preventEnterSubmit = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  // FIX 2026-09-30 (#9): the Kendo masked boxes return the mask's "_" placeholders
  // (e.g. "123_" for a 3-digit CVV) - always work with digits only.
  const digitsOnly = (value) => (value || "").toString().replace(/\D/g, "");

  // FIX 2026-09-30 (#10): standard card-number check digit (Luhn).
  const passesLuhn = (cardNo) => {
    const n = digitsOnly(cardNo);
    if (n.length < 13) return false;
    let sum = 0;
    let doubleIt = false;
    for (let i = n.length - 1; i >= 0; i--) {
      let d = parseInt(n.charAt(i), 10);
      if (doubleIt) {
        d *= 2;
        if (d > 9) d -= 9;
      }
      sum += d;
      doubleIt = !doubleIt;
    }
    return sum % 10 === 0;
  };
  const formValidation = () => {
    const dataCardTypeErrorMessage = {};
    const dataCardUserNameErrorMessage = {};
    const dataCardNoErrorMessage = {};
    const dataCardExpirationMonthErrorMessage = {};
    const dataCardExpirationYearErrorMessage = {};
    const dataCardSecurityCodeErrorMessage = {};
    const dataCardZipcodeErrorMessage = {};
    const dataCardEmailErrorMessage = {};

    let isValid = true;

    console.log(form.dataCardType);
    // validate card type
    if (form.dataCardType === "") {
      dataCardTypeErrorMessage.ErrorMessage = "Please select Card Type";
      isValid = false;
    } else {
      if (form.dataCardType === "0") {
        if (!form.dataCardNo.startsWith("4")) {
          dataCardTypeErrorMessage.ErrorMessage = "Invalid Card Type";
          isValid = false;
        }
      } else if (form.dataCardType === "1") {
        // FIX 2026-09-30 (#10): Mastercard also issues 2221-2720 numbers, not just 51-55.
        if (!/^(5[1-5]|222[1-9]|22[3-9]\d|2[3-6]\d\d|27[01]\d|2720)/.test(digitsOnly(form.dataCardNo))) {
          dataCardTypeErrorMessage.ErrorMessage = "Invalid Card Type";
          isValid = false;
        }
      } else if (form.dataCardType === "2") {
        // FIX 2026-09-30 (#10): American Express numbers start with 34 or 37.
        if (!/^3[47]/.test(digitsOnly(form.dataCardNo))) {
          dataCardTypeErrorMessage.ErrorMessage = "Invalid Card Type";
          isValid = false;
        }
      }
    }

    // validate card name
    if (form.dataCardUserName === "") {
      dataCardUserNameErrorMessage.ErrorMessage = "Please check Card UserName";
      isValid = false;
    }

    console.log("test");
    console.log(form.dataCardNo < 1);
    // validate card no
    if (form.dataCardNo === "") {
      dataCardNoErrorMessage.ErrorMessage = "Please check Card No.";
      isValid = false;
    } else if (isNaN(form.dataCardNo)) {
      dataCardNoErrorMessage.ErrorMessage = "Invalid Card No.";
      isValid = false;
    } else if (!passesLuhn(form.dataCardNo)) {
      // FIX 2026-09-30 (#10): catches typos before charging the $0.02 check.
      dataCardNoErrorMessage.ErrorMessage = "Invalid Card No. Please check the number.";
      isValid = false;
    }

    // FIX 2026-09-30 (#9): month must be 1-12 (was <= 31), year must be 4 digits with its errors
    // shown under the YEAR (they went to the month), no expired cards, CVV 3 digits (4 for Amex).
    const expMonth = digitsOnly(form.dataCardExpirationMonth);
    const expYear = digitsOnly(form.dataCardExpirationYear);
    const securityCode = digitsOnly(form.dataCardSecurityCode);

    // validate card expiry month
    if (expMonth === "") {
      dataCardExpirationMonthErrorMessage.ErrorMessage =
        "Please check Card Expiration Month";
      isValid = false;
    } else if (isNaN(expMonth)) {
      dataCardExpirationMonthErrorMessage.ErrorMessage =
        "Invalid Expiration Month";
      isValid = false;
    } else if (parseInt(expMonth, 10) < 1) {
      dataCardExpirationMonthErrorMessage.ErrorMessage =
        "Invalid Expiration Month";
      isValid = false;
    } else if (parseInt(expMonth, 10) > 12) {
      dataCardExpirationMonthErrorMessage.ErrorMessage =
        "Invalid Expiration Month";
      isValid = false;
    }

    // validate card expiry year
    if (expYear === "") {
      dataCardExpirationYearErrorMessage.ErrorMessage =
        "Please check Card Expiration Year";
      isValid = false;
    } else if (expYear.length !== 4) {
      dataCardExpirationYearErrorMessage.ErrorMessage =
        "Invalid Expiration Year";
      isValid = false;
    } else if (expMonth !== "" && parseInt(expMonth, 10) >= 1 && parseInt(expMonth, 10) <= 12) {
      const now = new Date();
      const y = parseInt(expYear, 10);
      const m = parseInt(expMonth, 10);
      if (y < now.getFullYear() || (y === now.getFullYear() && m < now.getMonth() + 1)) {
        dataCardExpirationYearErrorMessage.ErrorMessage = "This card has expired";
        isValid = false;
      }
    }

    // validate card security code
    if (securityCode === "") {
      dataCardSecurityCodeErrorMessage.ErrorMessage =
        "Please check Card Security code";
      isValid = false;
    } else if (securityCode.length !== (form.dataCardType === "2" ? 4 : 3)) {
      dataCardSecurityCodeErrorMessage.ErrorMessage =
        form.dataCardType === "2"
          ? "Security code must be 4 digits for American Express"
          : "Security code must be 3 digits";
      isValid = false;
    }

    // validate card expiry year
    if (form.dataCardZipcode === "") {
      dataCardZipcodeErrorMessage.ErrorMessage = "Please check Card Zip code";
      isValid = false;
    }

    if (form.dataCardEmail === "") {
      dataCardEmailErrorMessage.ErrorMessage = "Please check Card user Email";
      isValid = false;
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(form.dataCardEmail)
    ) {
      dataCardEmailErrorMessage.ErrorMessage = "Invalid Email address";
      isValid = false;
    }

    if (isValid) {
      console.log("Authenticated"); // FIX 2026-09-30 (PCI): do not log the card form
    } else {
      console.log("errors try again");
    }

    setDataCardTypeErrorMessage(dataCardTypeErrorMessage);
    setDataCardUserNameErrorMessage(dataCardUserNameErrorMessage);
    setDataCardNoErrorMessage(dataCardNoErrorMessage);
    setDataCardExpirationMonthErrorMessage(dataCardExpirationMonthErrorMessage);
    setDataCardExpirationYearErrorMessage(dataCardExpirationYearErrorMessage);
    setDataCardSecurityCodeErrorMessage(dataCardSecurityCodeErrorMessage);
    setDataCardZipcodeErrorMessage(dataCardZipcodeErrorMessage);
    setDataCardEmailErrorMessage(dataCardEmailErrorMessage);

    return isValid;
  };

  const getDataIPAddress = async () => {
    return true;
  };

  const callPayment = async () => {
    console.log("entered payment call");
    let strDataCardType = "";
    // FIX 2026-09-30: the client-IP lookup is a third-party service. If an ad-blocker/tracking
    // protection blocks it or it is down, the card update used to fail silently. The IP is
    // optional for the gateway, so carry on without it.
    let IPAddress = "";
    try {
      const res = await axios.get("https://geolocation-db.com/json/", { timeout: 5000 });
      if (res && res.data && res.data.IPv4) {
        IPAddress = res.data.IPv4.toString();
      }
    } catch (ipError) {
      console.warn("Client IP lookup failed - continuing without it");
    }

    {
      console.log("IP Address done");
      console.log(IPAddress);
      switch (form.dataCardType) {
        case "0":
          strDataCardType = "VISA";
          break;
        case "1":
          strDataCardType = "MASTERCARD";
          break;
        case "2":
          strDataCardType = "AMEX";
          break;
        default:
          strDataCardType = "";
          break;
      }

      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          AppId: appId,
          TokenId: localStorage.getItem("TokenId"),
          strPaymentAction: "Auto-Renewal Membership Settings",
          dAmount: 0.02,
          strCardType: strDataCardType,
          strNameOnCard: form.dataCardUserName,
          // FIX 2026-09-30 (#9): send digits only (no mask "_" placeholders)
          strCreditCardNumber: digitsOnly(form.dataCardNo),
          strCardExpiryMonth: digitsOnly(form.dataCardExpirationMonth),
          strCardExpiryYear: digitsOnly(form.dataCardExpirationYear),
          strCardCvv: digitsOnly(form.dataCardSecurityCode),
          strCurrencyCode: "USD",
          strZip: form.dataCardZipcode,
          strEmail: form.dataCardEmail,
          //strUserId: decodedUserId,
          strUserId: UserID,
          strIdentification: MemberUSEAID,
          strUserHostAddress: "",
          strClientIP: IPAddress,
          strStaffUserId: "",
        }),
      };

      // FIX 2026-09-30 (PCI): do not log requestOptions - the body holds the card number and CVV.
      let postPaymentUpdateURLAPI = urlAPI + "OSPortalPaymentUpdateDetailsPost";
      const response = await fetch(postPaymentUpdateURLAPI, requestOptions);
      const data = await response.json();
      if (data.TokenInfoDetails.TokenResponse == "Expired") {
        renewToken();
      }
      console.log("Post payment call");
      console.log(response);
      if (!response.ok) {
        throw new Error("Data cound not be fetched!");
      } else {
        console.log(response);
        return data;
      }
    }
  };

  const callPaymentErrorDetails = async (strPaymentStatusErrorCode) => {
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };

    let getPaymentErrorDetailsUrlAPI =
      urlAPI +
      "GetOSPortalPaymentErrorDetails?AppId=" +
      appId +
      "&TokenId=" +
      getTokenFromStorage() +
      "&strErrorCode=" +
      strPaymentStatusErrorCode;
    const response = await fetch(getPaymentErrorDetailsUrlAPI, requestOptions);
    const data = await response.json();
    if (data.TokenInfoDetails.TokenResponse == "Expired") {
      renewToken();
    }
    if (!response.ok) {
      throw new Error("Data Payment error details cound not be fetched!");
    } else {
      console.log(response);
      return data;
    }
  };

  function onCloseCardDetailsClick(event) {
    const strPaymentFailureShortMessage = {};
    const strPaymentFailureLongMessage = {};

    props.updateShowCardDetailsPopup(!props.isShowCardDetailsPopup);
    setDataPaymentFailureShortErrorMessage(strPaymentFailureShortMessage);
    setDataPaymentFailureLongErrorMessage(strPaymentFailureLongMessage);

    setIsPaymentSuccess(false);
  }

  return (
    <div className={classes.divFieldSetDetails} onKeyDown={preventEnterSubmit}>
      {props.isShowCardDetailsPopup ? (
        <fieldset className={classes.fieldsetUpdateCardDetailsData}>
          <div className={classes.divUpdateCardDetails}>
            <CardHeader
              className="payment_title"
              title="Update Payment"
              sx={{ textAlign: "center", p: "0 !important" }}
            />
          </div>
          <div>
            <div className={classes.divCardDetails}>
              <span className={classes.spanCardDetails}>
                <i class="fa fa-cc-visa fa-3x" aria-hidden="true"></i>
              </span>
              <span className={classes.spanCardDetails}>
                <i class="fa fa-cc-mastercard fa-3x" aria-hidden="true"></i>
              </span>
              <span className={classes.spanCardDetails}>
                <i class="fa fa-cc-amex fa-3x" aria-hidden="true"></i>
              </span>
            </div>
            {Object.keys(dataPaymentFailureShortErrorMessage).map((key) => {
              return (
                <div className={classes.lblFailureErrorMessages}>
                  {dataPaymentFailureShortErrorMessage[key]}
                  <br />
                </div>
              );
            })}
            {Object.keys(dataPaymentFailureLongErrorMessage).map((key) => {
              return (
                <div className={classes.lblFailureErrorMessages}>
                  {dataPaymentFailureLongErrorMessage[key]}
                  <br />
                  <br />
                </div>
              );
            })}
            <Typography variant="body2" className="payment_text">
              Payment Amount
            </Typography>
            <div className={classes.divPaymentText}>
              <div className={classes.divPaymentTextLeft}>
                <Typography className="PaymentTextLeft">$0.02</Typography>
              </div>
              <div className={classes.divPaymentTextRight}>
                <Typography className="PaymentTextLeft">
                  use to validate the card and immediately refunded.
                </Typography>
              </div>
            </div>
            <br />
            {isPaymentSuccess ? (
              <div>
                <span className="PaymentTextLeft">Card details updated.</span>
              </div>
            ) : (
              <div>
                <div>
                  <div className={classes.divCardDataDetails}>
                    <Typography
                      variant="body2"
                      className="payment_text"
                      sx={{ mb: "10px !important" }}
                    >
                      Card Type
                    </Typography>
                    <label className="payment_icon">
                      <input
                        type="radio"
                        class="hide"
                        name="dataCardType"
                        value="0"
                        onChange={onUpdateField}
                      />
                      &nbsp;
                      <i class="fa fa-cc-visa fa-2x" aria-hidden="true"></i>
                    </label>
                    <label className="payment_icon">
                      <input
                        type="radio"
                        class="hide"
                        name="dataCardType"
                        value="1"
                        onChange={onUpdateField}
                      />
                      &nbsp;
                      <i
                        class="fa fa-cc-mastercard fa-2x"
                        aria-hidden="true"
                      ></i>
                    </label>
                    <label className="payment_icon">
                      <input
                        type="radio"
                        class="hide"
                        name="dataCardType"
                        value="2"
                        onChange={onUpdateField}
                      />
                      &nbsp;
                      <i class="fa fa-cc-amex fa-2x" aria-hidden="true"></i>
                    </label>
                    {Object.keys(dataCardTypeErrorMessage).map((key) => {
                      return (
                        <div className={classes.lblErrors}>
                          {dataCardTypeErrorMessage[key]}
                        </div>
                      );
                    })}
                  </div>
                  <div className={classes.divCardDataDetails}>
                    <span className={classes.lblCardDetailsPayment}>
                      Name on Card
                    </span>
                    <input
                      type="text"
                      className={classes.txtboxDetails}
                      name="dataCardUserName"
                      value={
                        props.objModelMembershipDetails.CreditCardDetails
                          .CreditCardName
                      }
                      onChange={onUpdateField}
                    />
                    {Object.keys(dataCardUserNameErrorMessage).map((key) => {
                      return (
                        <div className={classes.lblErrors}>
                          {dataCardUserNameErrorMessage[key]}
                        </div>
                      );
                    })}
                  </div>
                  <div className={classes.divCardDataDetails}>
                    <span className={classes.lblCardDetailsPayment}>
                      Card Number
                    </span>
                    <input
                      type="text"
                      className={classes.txtboxDetails}
                      name="dataCardNo"
                      onChange={onUpdateField}
                      maxLength="16"
                    />
                    {Object.keys(dataCardNoErrorMessage).map((key) => {
                      return (
                        <div className={classes.lblErrors}>
                          {dataCardNoErrorMessage[key]}
                        </div>
                      );
                    })}
                  </div>
                  <div className={classes.divCardDataDetails}>
                    <div className={classes.divExpirationText}>
                      <div className={classes.divExpirationTextLeft}>
                        <span className={classes.lblCardDetailsPayment}>
                          Expiration Date (MM/YYYY)
                        </span>
                      </div>
                      <div className={classes.divExpirationTextRight}>
                        <span className={classes.lblCardDetailsPayment}>
                          Security Code
                        </span>
                      </div>
                    </div>
                    <div className={classes.divExpirationText}>
                      <div className={classes.divExpirationTextLeft}>
                        {/*                                                         <input type="text"
                                                            className={classes.txtboxExpirationDetails}
                                                            name='dataCardExpirationMonth'
                                                            onChange={onUpdateField}
                                                            maxLength="2"
                                                            max="31" /> */}
                        <MaskedTextBox
                          className={classes.txtboxExpirationDetails}
                          name="dataCardExpirationMonth"
                          onChange={onUpdateField}
                          mask="##"
                          maxLength="2"
                          max="31"
                          defaultValue="##"
                        />
                        <span> / </span>
                        <MaskedTextBox
                          className={classes.txtboxExpirationDetails}
                          name="dataCardExpirationYear"
                          onChange={onUpdateField}
                          maxLength="4"
                          mask="####"
                          defaultValue="####"
                        />
                      </div>
                      <div className={classes.divExpirationTextRight}>
                        {/* FIX 2026-09-30: was a Kendo MaskedTextBox with mask "####", which always
                            showed 4 blank slots - confusing for the usual 3-digit code. Now a plain
                            digits-only box sized to the card: 3 digits, or 4 for American Express. */}
                        <input
                          type="text"
                          inputMode="numeric"
                          autoComplete="cc-csc"
                          className={`${classes.txtboxDetails} ${classes.txtboxSecurityCodeDetails}`}
                          name="dataCardSecurityCode"
                          value={form.dataCardSecurityCode}
                          onChange={onUpdateField}
                          maxLength={form.dataCardType === "2" ? 4 : 3}
                          placeholder={form.dataCardType === "2" ? "4 digits" : "3 digits"}
                        />
                        <div className={classes.lblSecurityCodeHint}>
                          {form.dataCardType === "2"
                            ? "4-digit code on the front of the card"
                            : "3-digit code on the back of the card"}
                        </div>
                      </div>
                    </div>
                    {Object.keys(dataCardExpirationMonthErrorMessage).map(
                      (key) => {
                        return (
                          <div className={classes.lblErrors}>
                            {dataCardExpirationMonthErrorMessage[key]}
                          </div>
                        );
                      }
                    )}
                    {Object.keys(dataCardExpirationYearErrorMessage).map(
                      (key) => {
                        return (
                          <div className={classes.lblErrors}>
                            {dataCardExpirationYearErrorMessage[key]}
                          </div>
                        );
                      }
                    )}
                    {Object.keys(dataCardSecurityCodeErrorMessage).map(
                      (key) => {
                        return (
                          <div className={classes.lblErrors}>
                            {dataCardSecurityCodeErrorMessage[key]}
                          </div>
                        );
                      }
                    )}
                  </div>
                  <div className={classes.divCardDataDetails}>
                    <span className={classes.lblCardDetailsPayment}>
                      Zip/Postal Code
                    </span>
                    <input
                      type="text"
                      className={classes.txtboxDetails}
                      name="dataCardZipcode"
                      onChange={onUpdateField}
                    />
                    {Object.keys(dataCardZipcodeErrorMessage).map((key) => {
                      return (
                        <div className={classes.lblErrors}>
                          {dataCardZipcodeErrorMessage[key]}
                        </div>
                      );
                    })}
                  </div>
                  <div className={classes.divCardDataDetails}>
                    <span className={classes.lblCardDetailsPayment}>Email</span>
                    <br />
                    <input
                      type="text"
                      className={classes.txtboxDetails}
                      name="dataCardEmail"
                      onChange={onUpdateField}
                    />
                    {Object.keys(dataCardEmailErrorMessage).map((key) => {
                      return (
                        <div className={classes.lblErrors}>
                          {dataCardEmailErrorMessage[key]}
                        </div>
                      );
                    })}
                  </div>
                  <div className={classes.divButtonGroup}>
                    <Button themeColor={"primary"} onClick={onSubmitForm}>
                      Update Card
                    </Button>
                  </div>
                </div>
              </div>
            )}
            <div className={classes.divButtonGroup}>
              <a
                href="#"
                className={classes.aCloseLink}
                onClick={onCloseCardDetailsClick}
              >
                Close
              </a>
            </div>
          </div>
        </fieldset>
      ) : (
        <br />
      )}
    </div>
  );
};

export default UpdateCreditCardOnFile;
